import * as React from 'react';
import { compose } from 'recompose';
import { reduxForm } from 'redux-form';
import { Grid, Row, Col } from 'react-flexbox-grid';
import Divider from 'material-ui/Divider';

import Button from '@inqool/uas-web-core/es/components/controls/Button';

import { Upload, UploadField, Input, InputField } from '@components/form';

import * as T from '@modules/employees/_employeesTypes';

const enhance = compose<T.EmplyeesFormProps, T.Outter & T.EmplyeesFormProps>(
  reduxForm({
    form: 'module-employee-contracts'
  })
);

const View: React.SFC<T.Outter & T.EmplyeesFormProps> = ({ handleSubmit, closeItem }) => (
  <div>
    <form className="layout" onSubmit={handleSubmit}>
      <Grid fluid={true}>
        <Row>
          <Col className="grid-system-margin" />
        </Row>

        <Row>
          <Col md={12}>
            <Row>
              <Col md={4}>
                <h4>Soubor</h4>
              </Col>
              <Col md={8}>
                <UploadField component={Upload} name="fileRef" />
              </Col>
            </Row>
            <Row>
              <Col md={4}>
                <h4>Popis</h4>
              </Col>
              <Col md={8}>
                <InputField
                  component={Input}
                  multiLine={true}
                  name="description"
                  style={{ maxHeight: '60vh' }}
                  inputStyle={{ maxHeight: '60vh' }}
                  textareaStyle={{ maxHeight: '56vh' }}
                />
              </Col>
            </Row>
          </Col>
        </Row>
        <Row>
          <Col className="grid-system-margin" />
        </Row>
      </Grid>

      <Divider />

      <Button type="submit" label="Uložit a zavřít" primary={true} style={{ margin: '16px 0 16px 16px' }} />
      <Button label="Zrušit" style={{ margin: '16px 0 16px 16px' }} onClick={closeItem} />
    </form>
  </div>
);

export const EmployeesFormFilesForm = enhance(View);



// WEBPACK FOOTER //
// ./src/modules/employees/EmployeesFormFilesForm.tsx